import * as _ from "lodash";
import * as $ from "jquery";
import {BaseGenericModal, BaseGenericModalOptions} from "./_BaseGenericModal";
import {DashboardTabCollection} from "../../collections/DashboardTabs";

export interface GenericTabSelectModalOptions extends Omit<BaseGenericModalOptions, 'name'> {
    dashboardTabCollection: DashboardTabCollection;
    currentTabId?: number | null;
    name?: string; // Optional, not used in tab selection modal
}

export class GenericTabSelectModal extends BaseGenericModal {

    public options: GenericTabSelectModalOptions;
    private template = _.template(require('templates/modals/genericTabSelect.html'));

    constructor(options: GenericTabSelectModalOptions) {
        super(<any> _.extend({
            tagName: "div",
            events: {
                'shown.bs.modal #genericTabSelectModal': 'handleModalShown',
                'hidden.bs.modal #genericTabSelectModal': 'handleModalHidden',
                'click .generic-tab-select-modal-submit': 'handleSubmit',
                'change .generic-tab-select-modal-select': 'handleSelectChange'
            }
        }, options));
        this.genericIdSelector = 'genericTabSelectModal';
    }

    render() {
        var text = this.options.text || "Choose a new tab for this category:";
        var buttonText = this.options.buttonText || "Move";
        var titleText = this.options.titleText;
        var currentTabId = this.options.currentTabId;

        this.$el.html(this.template({
            elementId: 'genericTabSelectModal',
            text: text,
            buttonText: buttonText,
            titleText: titleText,
            tabs: this.options.dashboardTabCollection.models,
            currentTabId: currentTabId
        }));
        return this;
    };

    handleSubmit() {
        var selectedTabId = Number(this.$('.generic-tab-select-modal-select').val());
        
        if (!selectedTabId) {
            return;
        }

        this.setFormSubmitted();

        $.when(this.options.func(selectedTabId)).done(() => {
            this.hide();
        }).fail(() => {
            this.setFormError();
        });
    }

    handleSelectChange() {
        // Enable/disable submit button based on selection
        var selectedTabId = Number(this.$('.generic-tab-select-modal-select').val());
        var submitButton = this.$('.generic-tab-select-modal-submit');
        
        if (selectedTabId && selectedTabId !== this.options.currentTabId) {
            submitButton.prop('disabled', false);
        } else {
            submitButton.prop('disabled', true);
        }
    }

    handleModalShown() {
        // Set initial state of submit button
        // If current tab is selected (which it will be by default), disable submit button
        var selectedTabId = Number(this.$('.generic-tab-select-modal-select').val());
        var submitButton = this.$('.generic-tab-select-modal-submit');
        
        if (selectedTabId && selectedTabId !== this.options.currentTabId) {
            submitButton.prop('disabled', false);
        } else {
            submitButton.prop('disabled', true);
        }
    }
}




// WEBPACK FOOTER //
// ./srv/public/js/views/modals/GenericTabSelectModal.ts